/**
 * Several mailboxes' Sent folders as one list, newest first.
 *
 * Each folder is read as its newest N (the same window `useImapBrowse` reads
 * one folder with), and the merge keeps the newest N of all of them. That is
 * exact for the top N: any letter newer than the N-th of the merged list is
 * among the newest N of its own folder. Pure, so it is tested without a server.
 */
import type { ImapMessageRow } from "../../../../lib/mail";

/** One folder's answer, with where it came from. */
export interface SentPage {
  mailbox: string;
  path: string;
  uidValidity: string;
  rows: ImapMessageRow[];
  total: number;
}

/** A row of the merged list. `key` is unique across mailboxes; a UID is not. */
export interface SentAllRow extends ImapMessageRow {
  key: string;
  mailbox: string;
  path: string;
  uidValidity: string;
}

const time = (r: ImapMessageRow) => (r.date ? Date.parse(r.date) || 0 : 0);

export function mergeSent(pages: SentPage[], limit: number): { rows: SentAllRow[]; total: number } {
  const all: SentAllRow[] = pages.flatMap((p) =>
    p.rows.map((r) => ({
      ...r,
      key: `${p.mailbox}\n${p.path}\n${r.uid}`,
      mailbox: p.mailbox,
      path: p.path,
      uidValidity: p.uidValidity,
    })),
  );
  all.sort((a, b) => time(b) - time(a));
  return { rows: all.slice(0, limit), total: pages.reduce((n, p) => n + p.total, 0) };
}
